import { PageFooter } from './PageFooter';
export type { PageFooterProps } from './PageFooter';
export default PageFooter;
